import {
  browserLocalPersistence,
  GoogleAuthProvider,
  sendPasswordResetEmail,
  setPersistence,
  signInWithEmailAndPassword,
  signInWithPopup,
} from 'firebase/auth';
import { serverTimestamp, updateDoc } from 'firebase/firestore';
import { auth } from '@/lib/firebase';
import { userDoc } from '@/lib/firestore/refs';
import { resolveEmail } from './resolve-email';

export const GOOGLE_ENABLED = import.meta.env.VITE_AUTH_GOOGLE_ENABLED === 'true';
export const DEFAULT_DOMAIN = import.meta.env.VITE_AUTH_DEFAULT_DOMAIN ?? 'vetsrelief.com';

async function touchLastLogin(uid: string): Promise<void> {
  try {
    await updateDoc(userDoc(uid), { lastLoginAt: serverTimestamp() });
  } catch {
    // no profile yet or rules denied: AuthProvider handles the denial path
  }
}

export async function signInWithPassword(identifier: string, password: string): Promise<void> {
  const email = resolveEmail(identifier, DEFAULT_DOMAIN);
  await setPersistence(auth, browserLocalPersistence);
  const cred = await signInWithEmailAndPassword(auth, email, password);
  await touchLastLogin(cred.user.uid);
}

export async function signInWithGoogle(): Promise<void> {
  const provider = new GoogleAuthProvider();
  provider.setCustomParameters({ prompt: 'select_account' });
  await setPersistence(auth, browserLocalPersistence);
  const cred = await signInWithPopup(auth, provider);
  await touchLastLogin(cred.user.uid);
}

export async function sendReset(identifier: string): Promise<void> {
  await sendPasswordResetEmail(auth, resolveEmail(identifier, DEFAULT_DOMAIN));
}
